module.exports = __webpack_public_path__ + "img/project-next-app-banner-3.87221739.png";